import React from 'react';

interface PointOfInterestProps {
    shortPlaceName: string;
}

export const PointOfInterestPage: React.FunctionComponent<
    PointOfInterestProps
> = (props) => {
    return <h1>Point of Interest: {props.shortPlaceName}</h1>;
};
